// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getIOLLensTypes } from "../../../api";

export const useIOLLensTypes = () => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<string>>({
    queryKey: ["iol-lenstypes"],
    queryFn: async () => {
      const token = await getToken();
      return getIOLLensTypes(token);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
